export default __webpack_public_path__ + "static/media/milkshekelCoin.9f437fb2.svg";